import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { ClientIntakeService } from '../../../services/client_intakes/client-intake.service';

import { AddressService } from '../../../services/contacts/address.service';
import { ClientIntakeFieldService } from '../../../services/client_intakes/client-intake-field.service';
import { NotyService } from '../../../services/common/noty.service';
import { AuthService } from '../../../services/common/auth.service';

@Component({
  selector: 'app-client-intake-show',
  templateUrl: './client-intake-show.component.html',
  styleUrls: ['./client-intake-show.component.scss'],
})
export class ClientIntakeShowComponent implements OnInit {

  @Output() showModalCloseEvent: EventEmitter<object> = new EventEmitter();

  constructor(private route: ActivatedRoute, private router: Router, public clientIntakeService: ClientIntakeService, public notyService: NotyService, public addressService: AddressService, private authService: AuthService) {}

  /**
   * Contact id
   * @type {number}
  */
  @Input() clientIntakeId: number;

  @Input() editingClientIntakeStop: boolean;

  canEdit: boolean;

  clientIntake: any = {};

  clientIntakeFields: any = [];

  /**
   * Tells whether or not client intake form should be opened
   * @type {number}
  */
  @Output() editingClientIntake: EventEmitter<boolean> = new EventEmitter();

  @Output() clientIntakeForEditingForm: EventEmitter<object> = new EventEmitter();

  fieldType: any = {};

  user: any = {};

  ngOnInit() {
    this.loadClientIntake();
    if(this.editingClientIntakeStop){
     this.editingClientIntake.emit(false)
     this.clientIntakeForEditingForm.emit({})
    }
    this.user = this.authService.getUser();
    const user = this.user;
    if((user.id === this.clientIntake.created_by || this.clientIntake.updated_by) || user.isPriviledged() || user.isAdmin() || user.isIntake()){
      this.canEdit = true;
    }
    else{
      this.canEdit = false;
    }
  }

  loadClientIntake() {
    this.clientIntakeService.show(this.clientIntakeId).then(showSuccess=>{
    this.clientIntake = showSuccess;
    this.clientIntakeFields = showSuccess.client_intake_fields;
    console.log("showSuccess", showSuccess)
    }).catch(showError=>{
     console.log("showError", showError)
    })
  }

  new_line_to_br(str: string): string | void {
    if(str){
      return String(str).replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  }

  closeShowModal() {
    console.log("closeShowModal");
    this.showModalCloseEvent.emit({shouldClose: true})
  }

  createMatter(params: any) {
    this.clientIntakeService.createMatter(this.clientIntakeId, params).then(createMatterRe=>{
      console.log("createMatterRe", createMatterRe)
      if(createMatterRe.success){
        Object.assign(this.clientIntake, {matter_id: createMatterRe.matter_id, matter_name: createMatterRe.matter_name, matter_number: createMatterRe.matter_number, client_intake:{matter_id: createMatterRe.matter_id}})
        this.notyService.notify('Matter created successfully - redirecting', 'success')
        this.closeShowModal()
      }
    }).catch(
      createMatterErr=>{
        console.log("createMatterErr", createMatterErr)
      }
    )
  }

  editClientIntake() {
    this.clientIntakeService.edit(this.clientIntakeId).then(clientIntakeEditRe=>{
      console.log("clientIntakeEditRe from then block", clientIntakeEditRe)
      if(clientIntakeEditRe.client_intake_fields){
        for(let client_intake_field of clientIntakeEditRe.client_intake_fields){
          if(client_intake_field.client_intake_field_type){
            client_intake_field.field_type_obj = client_intake_field.client_intake_field_type;
          }
          else{
            client_intake_field.field_type_obj = client_intake_field.field_type.replace('Intake','');
          }
          if(client_intake_field.field_type_obj.data_type == 'checkbox' && client_intake_field.client_intake_field_value == '1')
            client_intake_field.client_intake_field_value = true;
        }
      }
      this.addressService.getContact({address_id: clientIntakeEditRe.default_appointment_address_id}).then(getContactRe=>{
        console.log("getContactRe", getContactRe)
      }).catch(getContactErr=>{
        console.log("getContactErr", getContactErr)
      });
      this.closeShowModal()
      this.editingClientIntake.emit(true)
      this.clientIntakeForEditingForm.emit(this.clientIntake)
    })
  }



  deleteClientIntake() {
    this.clientIntakeService.delete(this.clientIntakeId).then(clientIntakeDeleteRe=>{
      console.log("clientIntakeDeleteRe", clientIntakeDeleteRe)
      this.notyService.notify('Clientintake deleted successfully', 'success');
      this.closeShowModal()
    }).catch(clientIntakeDeleteErr=>{
      console.log("clientIntakeDeleteErr", clientIntakeDeleteErr)
      this.notyService.notify('Error deleting Clientintake', 'error');
    })
  }

  deleteclientIntakePermanently() {
    this.clientIntakeService.delete(this.clientIntakeId, true).then(clientIntakeDeletePermanentlyRe=>{
      console.log("clientIntakeDeletePermanentlyRe", clientIntakeDeletePermanentlyRe)
      this.notyService.notify('Clientintake successfully deleted permanently', 'success');
      this.closeShowModal()
    }).catch(clientIntakeDeleteErr=>{
      console.log("clientIntakeDeleteErr", clientIntakeDeleteErr)
      this.notyService.notify('Error deleting Clientintake permanently', 'error');
    })
  }

  unlockClientIntake() {
    this.clientIntakeService.unlock(this.clientIntakeId).then(unlockClientIntakeRe=>{
      console.log("unlockClientIntakeRe", unlockClientIntakeRe)
      this.notyService.notify('Client Intake unlocked', 'warning');
      this.clientIntake.locked = false;
    }).catch(unlockClientIntakeErr=>{
      console.log("unlockClientIntakeErr", unlockClientIntakeErr)
      this.notyService.notify('Error unlocking client Intake', 'error');
    })
  }
}
